import bhedaghat from "../assets/bhedaghat.webp";
import madan from "../assets/madan mahal.webp";
import balancing from "../assets/balancing.webp";
import gwarighat from "../assets/gwarigghat.webp";
import pisanhari from "../assets/Pisanhari Ki Madiya.webp";
import durgavati from "../assets/Rani Durgavati Museum.webp";
import nidan from "../assets/Nidan Falls.webp";
import kachnar from "../assets/Kachnar City Shiva Templ.webp";
import kanha from "../assets/kanha.webp";
import bandhavgarh from "../assets/bandhavgarh.webp";

export const Attractions = [
  {
    id: 1,
    title: "Bhedaghat – Marble Rocks & Dhuandhar Falls",
    image: bhedaghat,
    description:
      "Marble Rocks: A breathtaking gorge carved by the Narmada River, stretching around 3 km deep. Dhuandhar Falls: A dramatic waterfall where the Narmada plunges ~30 m, creating a misty 'smoke cascade.' Enjoy boat rides and a ropeway view.",
    location: "https://maps.app.goo.gl/U1X8JtS72MHqPypF8",
    wikiLink: "https://en.wikipedia.org/wiki/Bhedaghat",
  },
  {
    id: 2,
    title: "Madan Mahal Fort",
    image: madan,
    description:
      "An 11th-century hilltop fort built by Gond rulers, offering panoramic city views. The famous Balancing Rock stands on the trail up.",
    location: "https://maps.app.goo.gl/LUoAs9pX2K4ckWJo7",
    wikiLink: "https://en.wikipedia.org/wiki/Madan_Mahal",
  },

  {
    id: 4,
    title: "Balancing Rock",
    image: balancing,
    description:
      "A quirky geological formation featuring a massive rock that improbably balances atop another—even surviving earthquakes.",
    location: "https://maps.app.goo.gl/Fu7V9w8YEq1wV1Ac7",
    wikiLink: "https://jabalpurwala.com/listing/balancing-rock/",
  },
  {
    id: 5,
    title: "Gwarighat Ghats",
    image: gwarighat,
    description:
      "A sacred riverside ghat with evening aarti, temples, and a serene ambiance on the banks of the Narmada River.",
    location: "https://maps.app.goo.gl/gKwH2GvFkpZUKD5P9",
    wikiLink: "https://jabalpurwala.com/listing/gwarighat/",
  },
  {
    id: 6,
    title: "Pisanhari Ki Madiya & Hanumantal Jain Temple",
    image: pisanhari,
    description:
      "Pisanhari Ki Madiya: A 500-year-old Jain pilgrimage with impressive hilltop views. Hanumantal Jain Temple: One of India's largest Jain temples, rich in architecture and history.",
    location: "https://maps.app.goo.gl/SzvZwJPcRMzV4fP58",
    wikiLink: "https://en.wikipedia.org/wiki/Pisanhari_ki_Madiya",
  },

  {
    id: 8,
    title: "Rani Durgavati Museum",
    image: durgavati,
    description:
      "Founded in 1976 to commemorate Queen Durgavati, this museum features sculptures, relics, manuscripts, and archaeological finds.",
    location: "https://maps.app.goo.gl/ccX1Z5y3Fz97p5Wo9",
    wikiLink: "https://en.wikipedia.org/wiki/Rani_Durgavati_Museum",
  },
  {
    id: 9,
    title: "Nidan Falls (Katangi)",
    image: nidan,
    description:
      "A lesser-known but stunning waterfall (~100 ft) near Katangi village—calmer and perfect for peaceful exploration.",
    location: "https://maps.app.goo.gl/8Xszm6JY8P6FD3tH8",
    wikiLink: "https://jabalpurwala.com/listing/nidan-waterfall/",
  },
  {
    id: 10,
    title: "Kachnar City Shiva Temple",
    image: kachnar,
    description:
      "Home to a towering 76 ft Shiva statue and an underground cavern with replicas of lingams from multiple shrines.",
    location: "https://maps.app.goo.gl/FuPbyVo91Z1BfSrm9",
    wikiLink:
      "https://jabalpur.nic.in/en/tourist-place/kachnar-city-shiv-temple/",
  },
  {
    id: 11,
    title: "Kanha National Park",
    image: kanha,
    description:
      "A major tiger reserve and one of India’s largest national parks, home to tigers, leopards, and the rare Barasingha (swamp deer).",
    location: "https://maps.app.goo.gl/Vsf4AJpkeH1mrKDv5",
    wikiLink: "https://en.wikipedia.org/wiki/Kanha_National_Park",
  },
  {
    id: 12,
    title: "Bandhavgarh National Park",
    image: bandhavgarh,
    description:
      "One of India’s top tiger reserves with the highest density of tigers, along with rich biodiversity and historical significance.",
    location: "https://maps.app.goo.gl/Y6bNnoB8M7a4M59A6",
    wikiLink: "https://en.wikipedia.org/wiki/Bandhavgarh_National_Park",
  },
];
